import { getField, updateField } from 'vuex-map-fields';
import { client } from "@/api/client";

export const SET_NETWORK_DRIVES = "SET_NETWORK_DRIVES";

const state = () => ({
    headers: [
        {
            text: 'Letra',
            align: 'start',
            value: 'letter',
            sortable: false,
        },
        {
            text: 'Ruta',
            value: 'path',
            sortable: false,
        },
        {
            text: 'Usuario',
            value: 'user',
            sortable: false,
        },
    ],
    network_drive_id: '',
    path: '',
    letter: '',
    user: '',
    password: '',
    network_drives: [],
});

const getters = {
    getField,
}

const mutations = {
    updateField,
    [SET_NETWORK_DRIVES](state, network_drives) {
        state.network_drives = network_drives;
    },
}

const getNetworkDrives = ({ commit }) => {
    return new Promise((resolve, reject) => {
        client.get('get_network_drives/').then(response => {
            // this.network_drives = response.data['results'];
            commit(SET_NETWORK_DRIVES, response.data['results']);
            resolve();
        }).catch(err => {
            console.error(err);
            reject();
        });
    });
}

const createNetworkDrive = ({ state }) => {
    return new Promise((resolve, reject) => {
        let params = {
            'path': state.path,
            'letter': state.letter + ':',
            'user': state.user,
            'password': state.password,
        };
        client.post('create_network_drive/', params).then(() => {
            // this.closeDialog();
            // this.getNetworkDrives();
            resolve();
        }).catch(err => {
            console.error(err);
            reject();
        });
    });
}

const updateNetworkDrive = ({ state }) => {
    return new Promise((resolve, reject) => {
        let params = {
            'id': state.network_drive_id,
            'path': state.path,
            'letter': state.letter + ':',
            'user': state.user,
            'password': state.password,
        };
        client.patch('update_network_drive/', params).then(() => {
            // this.closeDialog();
            // this.getNetworkDrives();
            resolve();
        }).catch(err => {
            console.error(err);
            reject();
        });
    });
}

const actions = {
    getNetworkDrives,
    createNetworkDrive,
    updateNetworkDrive,
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}